"use client";
import { forwardRef } from "react";
import { SelectBase } from "./SelectBase.js";
const SingleSelect = forwardRef(function SingleSelect2(props, ref) {
  return SelectBase(props, false, ref);
});
export {
  SingleSelect
};
